import { getOwnProperty } from '../utils/getOwnProperty';
export function fetchPropertyValue(httpClient, objectTypeId, objectId, propertyName) {
  return httpClient.get(`inbounddb-objects/v1/crm-objects/${objectTypeId}/${objectId}?properties=${propertyName}`).then(response => {
    var _getOwnProperty;
    return (_getOwnProperty = getOwnProperty(response.properties, propertyName)) === null || _getOwnProperty === void 0 ? void 0 : _getOwnProperty.value;
  }).catch(error => {
    throw error;
  });
}